import { Box, Typography, Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

const topics = [
  {
    title: "Guide to Writing a Marriage Biodata",
    slug: "guidelines-for-marriage-biodata",
    category: "biodata",
    image: "/guidelines/Marriage.jfif", // ✅ FIXED
  },
  {
    title: "Biodata Format for Groom",
    slug: "biodata-format-for-groom",
    category: "biodata",
    image: "/articles/groom.jpg", // ✅ FIXED
  },
  {
    title: "Biodata Format for Bride",
    slug: "biodata-format-for-bride",
    category: "biodata",
    image: "/articles/bride.jpg", // ✅ FIXED
  },
  {
    title: "Marriage Certificate",
    slug: "marriage-certificate",
    category: "legal",
    image: "/articles/marriage-certificate.jpg",
  },
    {
    title: "Arranged vs Love Marriage in India",
    slug: "arranged-vs-love-marriage-india",
    category: "marriage",
    image: "/articles/arranged2.webp",
  },
  {
    title: "Marathi Marriage Biodata Format",
    slug: "marathi-marriage-biodata-format",
    category: "biodata",
    image: "/articles/MarathiWed.jpg",
  },
  {
    title: "Hindi Marriage Biodata Format",
    slug: "hindi-marriage-biodata-format",
    category: "biodata",
    image: "/articles/Hinduwed.jpg",
  },
    {
    title: "Modern Marriage Biodata Format 2026",
    slug: "modern-marriage-biodata-format-2026",
    category: "biodata",
    image: "/articles/modernBiodata.png",
  },
  {
    title:"Marriage Biodata for Software Engineers",
    slug: "marriage-biodata-for-software-engineers",
    category: "biodata",
    image: "/articles/SoftwareBiodata.webp",
  }
];
export default function RelevantTopics({ currentSlug, category }) {
  const navigate = useNavigate();

  const filtered = topics.filter(
    (t) => t.slug !== currentSlug && t.category === category
  );

  const fallback = topics.filter((t) => t.slug !== currentSlug);

  const finalTopics = filtered.length > 0 ? filtered : fallback;

  return (
    <Box sx={{ mt: 6 }}>
      <Typography variant="h5" fontWeight={700} mb={3}>
        Related Articles
      </Typography>

      {/* Cards */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(4, 1fr)",
          },
          gap: 2,
        }}
      >
        {finalTopics.map((topic) => (
          <Box
            key={topic.slug}
            onClick={() => navigate(`/articles/${topic.slug}`)}
            sx={{
              cursor: "pointer",
              p: 2,
              borderRadius: 2,
              background: "#fff",
              boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
              "&:hover": { transform: "translateY(-3px)" },
            }}
          >

              {/* ✅ IMAGE */}
          <Box
            component="img"
            src={topic.image}
            alt={topic.title}
            loading="lazy"
            sx={{
              width: "100%",
              height: 120,
              objectFit: "cover",
            }}
            onError={(e) => {
              e.target.src = "/fallback.jpg"; // optional fallback
            }}
          />
            <Typography fontWeight={600}>{topic.title}</Typography>
          </Box>
        ))}
      </Box>

      {/* SEO Sentence */}
      <Typography sx={{ mt: 2, fontSize: "0.95rem", color: "#555" }}>
        Explore more like{" "}
        {finalTopics.map((t, i) => (
          <span key={t.slug}>
            <Link to={`/articles/${t.slug}`}>{t.title}</Link>
            {i < 8 && ", "}
          </span>
        ))}
        .
      </Typography>

      {/* Button */}
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Button
          variant="contained"
          onClick={() => navigate("/articles")}
        >
          View All Articles
        </Button>
      </Box>
    </Box>
  );
}